import { useProjectLegacyActions } from '@store/migrationActions/useProjectLegacyActions'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import cx from 'classnames'
import type React from 'react'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { NODE_FRAME } from '@/constants/constants'
import { DEFAULT_PAGE_NAME } from '@/constants/defaultNames'
import type { TreeItemVariants } from '@/types'
import { replaceArrow } from '@/utils/replaceArrow'
import { Input } from './components/Input'
import css from './Name.module.scss'

type Props = {
  id: string
  isEditable: boolean
  name: string
  variant: TreeItemVariants
  className?: string
}

const Name: React.FC<Props> = ({ className = '', ...props }) => {
  const { updateNodeTitle } = useProjectLegacyActions()

  const [name, setName] = useState(props.name)

  const isNeutral = useSelector(migrationProjectSelector.getIsProjectNeutral)

  useEffect(() => {
    if (!props.isEditable && props.name !== name) {
      const replacedName = replaceArrow(name)
      updateNodeTitle({
        id: props.id,
        title: replacedName,
      })
    }
  }, [props.isEditable])

  useEffect(() => {
    if (props.name !== name) {
      setName(props.name)
    }
  }, [props.name])

  return (
    <div
      className={cx(css.container, className, {
        'node-name': !props.isEditable,
        [css.dashed]: props.variant === NODE_FRAME,
        [css.neutral]: isNeutral,
      })}
    >
      {props.isEditable ? (
        <Input
          name={name}
          setName={setName}
          variant={props.variant}
          id={props.id}
          readOnly={false}
        />
      ) : (
        <div data-testid="page-name" className={css.name}>
          {props.name === ' ' ? '\u00A0' : props.name || DEFAULT_PAGE_NAME}
        </div>
      )}
    </div>
  )
}

export default Name
